import axios from 'axios'
import { BUSCAR_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarEncomenda (idEncomenda, idEmpresa) {
  const url = `${URL}/encomendas/${idEncomenda}/empresa/${idEmpresa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ENCOMENDA,
        payload: response

      })
  );
}
